import { type EFeatureFlag } from '@mahawi/eshop-common/dist/src/types';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { PUBLIC_FEATURE_FLAGS } from '../../reducers/products/types';

export function hasVisibleFeatureFlagOptions(
  availableFlags: EFeatureFlag[] | null,
  value: EFeatureFlag[],
): boolean {
  return !((availableFlags?.length ?? 0) <= 1 && value.length === 0);
}

function FeatureFlagQuickFilter({
  value,
  availableFlags,
  onChange,
}: {
  value: EFeatureFlag[];
  availableFlags: EFeatureFlag[] | null;
  onChange: (next: EFeatureFlag[]) => void;
}): ReactElement | null {
  const { t } = useTranslation();

  if (!hasVisibleFeatureFlagOptions(availableFlags, value)) {
    return null;
  }

  const visibleFlags = PUBLIC_FEATURE_FLAGS.filter(
    (flag: EFeatureFlag): boolean =>
      value.includes(flag) || Boolean(availableFlags?.includes(flag)),
  );

  return (
    <div className="pf-group">
      <p className="pf-group__label">
        {t('products.filter.flags.label', { defaultValue: 'Labels' })}
      </p>
      <div className="pf-chips">
        {visibleFlags.map((flag: EFeatureFlag): ReactElement => {
          const isSelected = value.includes(flag);

          return (
            <button
              key={flag}
              type="button"
              className={`pf-chip${isSelected ? ' pf-chip--active' : ''}`}
              aria-pressed={isSelected}
              onClick={(): void =>
                onChange(
                  isSelected
                    ? value.filter((f: EFeatureFlag): boolean => f !== flag)
                    : [...value, flag],
                )
              }
            >
              {t(`product.featureFlag.${flag}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FeatureFlagQuickFilter;
